/* eslint-disable max-len */
import _ from 'lodash';
import pages from './pages.json';
import PageRecord from '../PageRecord';

const initialValue = {
  pages: _.sortBy(pages.pages.map(data => new PageRecord(data)), 'order'),
};

// the "reducer" is a noop function that returns the pages. There are no providers/actions.

export default () => ({ ...initialValue });
